// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1yCOb","content":"ManualTimeModal_content__3k5AX"};